export { default } from './IncludedBadge';
